import { useQuery } from "react-query";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IAttributeModel } from "../../services/attribute-data-service/Models";

export type UseCustomerAttributeParameters = {
    groupID: number,
    name: string
} & BaseUseQueryParameters<IAttributeModel | undefined>;

export function useCustomerAttribute({
    groupID,
    name,
    enabled,
    onError,
    onSuccess,
}: UseCustomerAttributeParameters) {
    return useQuery<IAttributeModel, RestError>(
        keys.getCustomerAttribute(groupID, name),
        ({ signal }) => {
            return AttributeDataService.getCustomerAttribute(
                groupID, 
                name,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity
        }
    );
}